module.exports = __webpack_public_path__ + "static/img/dtbanner.6a5b628.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/dtbanner.jpg
// module id = 4Bkl
// module chunks = 6